import {combineReducers} from "redux";
import users from "./users/userReducer";
import tracker from "./tracker/trackerReducer";
import session from "./session/sessionReducer";
import switches from "./switch/switchReducer";
import badge from "./badge/badgeReducer";

const rootReducer = combineReducers({
	users, tracker, session, switches, badge
});

export default rootReducer;
